// These holidays come from https://canada-holidays.ca/api/v1/holidays.
// I didn't want to depend on an external website so I cached the response
// for the next 2 years.
const holidays = [
  "2024-01-01",
  "2024-02-19",
  "2024-03-17",
  "2024-03-29",
  "2024-04-01",
  "2024-04-23",
  "2024-05-20",
  "2024-06-21",
  "2024-06-24",
  "2024-07-01",
  "2024-07-09",
  "2024-07-12",
  "2024-08-05",
  "2024-08-07",
  "2024-08-19",
  "2024-09-02",
  "2024-09-30",
  "2024-10-14",
  "2024-11-11",
  "2024-12-25",
  "2024-12-26",
  "2025-01-01",
  "2025-02-17",
  "2025-03-17",
  "2025-04-18",
  "2025-04-21",
  "2025-04-23",
  "2025-05-19",
  "2025-06-21",
  "2025-06-24",
  "2025-07-01",
  "2025-07-09",
  "2025-07-12",
  "2025-08-04",
  "2025-08-06",
  "2025-08-18",
  "2025-09-01",
  "2025-09-30",
  "2025-10-13",
  "2025-11-11",
  "2025-12-25",
  "2025-12-26",
  "2026-01-01",
  "2026-02-16",
  "2026-03-17",
  "2026-04-03",
  "2026-04-06",
  "2026-04-23",
  "2026-05-18",
  "2026-06-21",
  "2026-06-24",
  "2026-07-01",
  "2026-07-09",
  "2026-07-12",
  "2026-08-03",
  "2026-08-05",
  "2026-08-17",
  "2026-09-07",
  "2026-09-30",
  "2026-10-12",
  "2026-11-11",
  "2026-12-25",
  "2026-12-26",
];

export const isHoliday = (yyyymmdd: string): boolean =>
  holidays.includes(yyyymmdd);
